import './index.css';
import React, {  useContext, useState, useEffect, useRef } from 'react';
import { AuthContext } from './App';
import { useNavigate  } from 'react-router-dom';
import axios from 'axios';
import { ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, ChevronDownIcon, SortDescendingIcon, PlusCircleIcon, MinusCircleIcon, ChatIcon} from '@heroicons/react/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignLanguage, faBookmark, faShareAlt } from '@fortawesome/free-solid-svg-icons';
import CountdownTimer from "./Countdown";

function Browse() {
    const [filters, setFilters] = useState({
        companyName: [],
        titleName: [],
        location: [],
        degree: [],
        status: [],
        workMode: [],
        level: [],
        minExperience: '',
        maxExperience: '',
        minTotalCompensation: '',
        maxTotalCompensation: '',
        minSalary: '',
        maxSalary: '',
        minStock: '',
        maxStock: '',
        minTargetBonus: '',
        maxTargetBonus: '',
        minSignOnBonus: '',
        maxSignOnBonus: '',
        limit: 5
    });
      
    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
    const [results, setResults] = useState([]);
    const [showBasicFilters, setShowBasicFilters] = useState(true);
    const [showAdvancedFilters, setShowAdvancedFilters] = useState(false); // State to control the visibility of the basic filters drawer
    const [showOptionsFilters, setShowOptionsFilters] = useState(false); 
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [documentCount, setDocumentCount] = useState([]);
    const [bookmarks, setBookmarks] = useState(new Set());
    const [searchResults, setSearchResults] = useState([]);
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [companyInput, setCompanyInput] = useState("");
    const [titleSearchResults, setTitleSearchResults] = useState([]);
    const [isTitleDropdownVisible, setIsTitleDropdownVisible] = useState(false);
    const [titleInput, setTitleInput] = useState("");
    const [locationSearchResults, setLocationSearchResults] = useState([]);
    const [isLocationDropdownVisible, setIsLocationDropdownVisible] = useState(false);
    const [locationInput, setLocationInput] = useState("");
    const [currency, setCurrency] = useState('USD');
    const [rates, setRates] = useState({});
    const [showDropdown, setShowDropdown] = useState(false);
    const [sortField, setSortField] = useState('experience');
    const [sortOrder, setSortOrder] = useState('ascending');
    const { auth } = useContext(AuthContext);
    const navigate = useNavigate();
    const searchRef = useRef(null);
    const titleSearchRef = useRef(null);
    const locationSearchRef = useRef(null);
    const sortingSearchRef = useRef(null);
    // const drawerStyle = `fixed bottom-0 bg-white border m-2 transition-transform duration-500 ease-in-out transform lg:rounded lg:border-1 lg:border-black lg:shadow-solid lg:bg-transparent lg:relative ${isFilterDrawerOpen ? 'translate-y-0' : 'translate-y-full'} lg:translate-y-0 opacity-${isFilterDrawerOpen ? '100' : '0'} lg:opacity-100 visibility-${isFilterDrawerOpen ? 'visible' : 'invisible'} lg:visibility-visible w-full lg:w-80`;
    const drawerStyle = `fixed bottom-0 left-0 right-0 z-50 m-0 transition-transform  h-full relative rounded border-2 border-black  w-80`;
      
    useEffect(() => {
        fetchFilteredJobOffers();
        if (auth.isLoggedIn) {
            fetchBookmarks();
        }
    }, [currentPage, sortField, sortOrder, auth.isLoggedIn, auth.user]); // Fetch data on currentPage or filters change

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setIsDropdownVisible(false);
            }

            if (titleSearchRef.current && !titleSearchRef.current.contains(event.target)) {
                setIsTitleDropdownVisible(false);
            }

            if (locationSearchRef.current && !locationSearchRef.current.contains(event.target)) {
                setIsLocationDropdownVisible(false);
            }

            if (sortingSearchRef.current && !sortingSearchRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
    
        document.addEventListener('mousedown', handleClickOutside);
    
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    
    useEffect(() => {
        axios.get('https://api.finaloffers.fyi/api/rates')
            .then(response => {
                setRates(response.data);
            })
            .catch(error => console.error('Error fetching currency rates:', error));
    }, []);

    const handleChange = (e) => {
        const { name, value, checked } = e.target;

        if (name === 'level'){
            setFilters(prevFilters => {
                const newLevel = checked
                    ? [...prevFilters.level, value]
                    : prevFilters.level.filter(mode => mode !== value);
                return {
                    ...prevFilters,
                    level: newLevel
                };
            });
        }
        else if (name === 'degree') {
            setFilters(prevFilters => {
                const newDegree = checked
                    ? [...prevFilters.degree, value]
                    : prevFilters.degree.filter(mode => mode !== value);
                return {
                    ...prevFilters,
                    degree: newDegree
                };
            });
        }
        else if (name === 'status') {
            setFilters(prevFilters => {
                const newStatus = checked
                    ? [...prevFilters.status, value]
                    : prevFilters.status.filter(mode => mode !== value);
                return {
                    ...prevFilters,
                    status: newStatus
                };
            });
        }
        else if (name === 'workMode') {
            setFilters(prevFilters => {
                const newWorkMode = checked
                    ? [...prevFilters.workMode, value]
                    : prevFilters.workMode.filter(mode => mode !== value);
                return {
                    ...prevFilters,
                    workMode: newWorkMode
                };
            });
        } else {
            setFilters(prevFilters => ({
            ...prevFilters,
            [name]: value
            }));
        }
        // const { name, value } = e.target;
        // setFilters(prevFilters => ({
        //   ...prevFilters,
        //   [name]: value
        // }));
    };
    
    const fetchFilteredJobOffers = async () => {
        // const queryParams = new URLSearchParams(filters).toString();
        const queryParams = new URLSearchParams({
            ...filters,
            titleName: filters.titleName.join('|'),
            location: filters.location.join('|'),
            // minSalary: convertToUSD(filters.minSalary, currency),
            // maxSalary: convertToUSD(filters.maxSalary, currency),
            sortField: sortField, // Ensure this is mapped correctly to the backend
            sortOrder: sortOrder, // Ensure this is mapped correctly to the backend
            page: currentPage,
            // limit: 5, // Or another number you see fit for page size
          }).toString();
    
        try {
          const response = await axios.get(`https://api.finaloffers.fyi/jobOffers/filtered?${queryParams}`);
          setResults([]); // Clear previous results first
          setResults(response.data.results);
          setDocumentCount(response.data.totalCount)
          setTotalPages(Math.ceil(response.data.totalCount / 5)); 
        } catch (error) {
          console.error("Failed to fetch job offers:", error);
          setResults([]);
        }
    };

    const toggleBasicFilters = () => {
        setShowBasicFilters(!showBasicFilters); // Toggle the visibility of the basic filters drawer
        // if(showAdvancedFilters){
        //     setShowAdvancedFilters(!showAdvancedFilters);
        // }
    };

    const toggleAdvancedFilters = () => {
        if(!showAdvancedFilters){
            setShowAdvancedFilters(!showAdvancedFilters);
            // if(showBasicFilters) setShowBasicFilters(!showBasicFilters);
        }
        else if(showAdvancedFilters){
            setShowAdvancedFilters(!showAdvancedFilters);
        }
    };

    const toggleOptionsFilters = () => {
        if(!showOptionsFilters){
            setShowOptionsFilters(!showOptionsFilters);
            // if(showBasicFilters) setShowBasicFilters(!showBasicFilters);
        }
        else if(showOptionsFilters){
            setShowOptionsFilters(!showOptionsFilters);
        }
    };

    const clearFilters = () => {
        setFilters({
            companyName: [],
            titleName: [],
            location: [],
            degree: [],
            status: [],
            workMode: [],
            level: [],
            minExperience: '',
            maxExperience: '',
            minTotalCompensation: '',
            maxTotalCompensation: '',
            minSalary: '',
            maxSalary: '',
            minStock: '',
            maxStock: '',
            minTargetBonus: '',
            maxTargetBonus: '',
            minSignOnBonus: '',
            maxSignOnBonus: '',
            limit: 5
        });


    };

    const handleCardClick = (documentId) => {
        navigate(`/jobOffer/${documentId}`);
    };

    // const fetchBookmarks = async () => {
    //     try {
    //         const response = await axios.get(`https://api.finaloffers.fyi/auth/user/${auth.user}/bookmarks`);
    //         const newBookmarks = {};
    //         response.data.forEach(jobOffer => {
    //             jobOffer.offers.forEach(offer => {
    //                 if (!newBookmarks[jobOffer._id]) {
    //                     newBookmarks[jobOffer._id] = new Set();
    //                 }
    //                 newBookmarks[jobOffer._id].add(offer._id.toString());
    //             });
    //         });
    //         setBookmarks(newBookmarks);
    //     } catch (error) {
    //         console.error("Failed to fetch bookmarks:", error);
    //     }
    // };

    const fetchBookmarks = async () => {
        try {
            const response = await axios.get(`https://api.finaloffers.fyi/auth/user/${auth.user}/bookmarks`);
            const newBookmarks = new Set(response.data.map(bookmark => bookmark._id.toString()));
            setBookmarks(newBookmarks);
        } catch (error) {
            console.error("Failed to fetch bookmarks:", error);
        }
    };
    
    // const toggleBookmark = async (documentId, offerId, e) => {
    //     e.stopPropagation(); // Prevent card click when clicking the button
    //     if (!auth.isLoggedIn) {
    //         alert("Please log in to bookmark jobs.");
    //         return;
    //     }
    //     try {
    //         await axios.post(`https://api.finaloffers.fyi/auth/toggle-bookmark`, {
    //             userId: auth.user,
    //             documentId,
    //             offerId
    //         });
    //         const newBookmarks = { ...bookmarks };
    //         if (!newBookmarks[documentId]) {
    //             newBookmarks[documentId] = new Set();
    //         }
    //         if (newBookmarks[documentId].has(offerId)) {
    //             newBookmarks[documentId].delete(offerId);
    //         } else {
    //             newBookmarks[documentId].add(offerId);
    //         }
    //         setBookmarks(newBookmarks); // Trigger re-render
    //     } catch (error) {
    //         console.error('Failed to toggle bookmark:', error);
    //     }
    // };

    const toggleFilterDrawer = () => {
        setIsFilterDrawerOpen(!isFilterDrawerOpen);
    };

    // const drawerStyle = `transition-transform duration-500 ease-in-out transform ${isFilterDrawerOpen ? 'translate-y-0' : '-translate-y-full'} lg:translate-y-0 opacity-${isFilterDrawerOpen ? '100' : '0'} lg:opacity-100 visibility-${isFilterDrawerOpen ? 'visible' : 'invisible'} lg:visibility-visible`;
   
    // const handleSelectCompany = (company) => {
    //     setFilters(prevFilters => ({
    //         ...prevFilters,
    //         companyName: [...new Set([...prevFilters.companyName, company])] // Ensures no duplicates
    //     }));
    //     setIsDropdownVisible(false);  // Hide dropdown after selection
    // };
    
    
    // const handleCompanySearchChange = (value) => {
    //     setFilters(prevFilters => ({ ...prevFilters, companyName: value }));
        
    //     if (value.length > 2) {
    //         axios.get(`https://api.finaloffers.fyi/api/companies?term=${value}`)
    //             .then(response => {
    //                 setSearchResults(response.data);
    //                 setIsDropdownVisible(true);
    //             })
    //             .catch(error => {
    //                 console.error('Error fetching companies:', error);
    //                 setSearchResults([]);
    //                 setIsDropdownVisible(false);
    //             });
    //     } else {
    //         setSearchResults([]);
    //         setIsDropdownVisible(false);
    //     }
    // };
    const handleCompanySearchChange = (value) => {
        setCompanyInput(value); // Update the input value
    
        if (value.length > 2) {
            axios.get(`https://api.finaloffers.fyi/api/companies?term=${value}`)
                .then(response => {
                    setSearchResults(response.data);
                    setIsDropdownVisible(true);
                })
                .catch(error => {
                    console.error('Error fetching companies:', error);
                    setSearchResults([]);
                    setIsDropdownVisible(false);
                });
        } else {
            setSearchResults([]);
            setIsDropdownVisible(false);
        }
    };
    
    const handleSelectCompany = (company) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            companyName: [...new Set([...prevFilters.companyName, company])] // Add to the array uniquely
        }));
        setIsDropdownVisible(false);  
        setCompanyInput(""); // Reset the input field
    };    

    const handleTitleSearchChange = (value) => {
        setTitleInput(value); // Update the input value
    
        if (value.length > 2) {
            axios.get(`https://api.finaloffers.fyi/api/titles?term=${value}`)
                .then(response => {
                    setTitleSearchResults(response.data);
                    setIsTitleDropdownVisible(true);
                })
                .catch(error => {
                    console.error('Error fetching companies:', error);
                    setTitleSearchResults([]);
                    setIsTitleDropdownVisible(false);
                });
        } else {
            setTitleSearchResults([]);
            setIsTitleDropdownVisible(false);
        }
    };
    
    const handleSelectTitle = (title) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            titleName: [...new Set([...prevFilters.titleName, title])] // Add to the array uniquely
        }));
        setIsTitleDropdownVisible(false);  
        setTitleInput(""); // Reset the input field
    };    

    const handleLocationSearchChange = (value) => {
        setLocationInput(value); // Update the input value
    
        if (value.length > 2) {
            axios.get(`https://api.finaloffers.fyi/api/locations?term=${value}`)
                .then(response => {
                    setLocationSearchResults(response.data);
                    setIsLocationDropdownVisible(true);
                })
                .catch(error => {
                    console.error('Error fetching companies:', error);
                    setLocationSearchResults([]);
                    setIsLocationDropdownVisible(false);
                });
        } else {
            setLocationSearchResults([]);
            setIsLocationDropdownVisible(false);
        }
    };
    
    const handleSelectLocation = (location) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            location: [...new Set([...prevFilters.location, location])] // Add to the array uniquely
        }));
        setIsLocationDropdownVisible(false);  
        setLocationInput(""); // Reset the input field
    };

    const convertToUSD = (amount, currency) => {
        const rate = rates[currency] || 1; // Default to 1 if rate not found
        return (amount / rate).toFixed(2);
    };
    
    const handleSalaryChange = (e, field) => {
        const value = e.target.value;
        setFilters(prevFilters => ({
            ...prevFilters,
            [field]: value
        }));
    };    

    const handleSelectSortField = (field) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            sortField: field
        }));
        setShowDropdown(false); // Optionally close the dropdown on selection
    };
    
    const handleSelectSortOrder = (order) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            sortOrder: order
        }));
    };

    // const sortOptionsMap = {
    //     "Popularity": "likes", 
    //     "Time (Date Posted)": "date",
    //     "Experience": "experience",
    //     "Total Compensation": "offers.salaryDetails.totalCompensation",
    //     "Base Salary": "offers.salaryDetails.baseSalary",
    //     "Average Annual Stock": "offers.salaryDetails.stock",
    //     "Annual Target Bonus": "offers.salaryDetails.targetBonus",
    //     "Total Signon Bonus": "offers.salaryDetails.signingBonus",
    //     "Offer Date": "offerdate",
    // };
    const sortOptionsMap = {
        "Popularity": { field: "likes", enabledStatuses: ["Any"] },
        "Time (Date Posted)": { field: "submissionTimestamp", enabledStatuses: ["Any"] },
        "Experience": { field: "experience", enabledStatuses: ["Any"] },
        "Total Compensation": { field: "offers.salaryDetails.totalCompensation", enabledStatuses: ["Offered", "Accepted"] },
        "Base Salary": { field: "offers.salaryDetails.baseSalary", enabledStatuses: ["Offered", "Accepted"] },
        "Average Annual Stock": { field: "offers.salaryDetails.stock", enabledStatuses: ["Offered", "Accepted"] },
        "Annual Target Bonus": { field: "offers.salaryDetails.targetBonus", enabledStatuses: ["Offered", "Accepted"] },
        "Total Signon Bonus": { field: "offers.salaryDetails.signingBonus", enabledStatuses: ["Offered", "Accepted"] },
        "Offer Date": { field: "offerdate", enabledStatuses: ["Offered", "Accepted"] },
    };
    
    
    // Reverse map to find the friendly name from the field path
    const reverseSortOptionsMap = Object.entries(sortOptionsMap).reduce((acc, [key, value]) => {
        acc[value] = key;
        return acc;
    }, {});

    const isSortingOptionEnabled = (enabledStatuses) => {
        return filters.status.some(status => enabledStatuses.includes(status)) || enabledStatuses.includes("Any");
    };
    
    
    return (
        <>
            <div className="flex flex-col lg:flex-row justify-center items-start min-h-screen bg-transparent pt-10 pb-10"> 
                <div className="lg:inline-flex w-full max-w-6xl">
                    <div className={drawerStyle}>
                        <div className="p-4">
                        {/* <div className="inline-flex w-full font-bold pb-1 m-3"> */}
                            {/* <button onClick={toggleBasicFilters} className="flex items-center justify-between font-bold py-2 ml-3 mt-3 transition duration-300 ease-in-out">
                                Search Filters
                                <ChevronDownIcon className={`w-5 h-5 transition-transform transform ${showBasicFilters ? 'rotate-180' : ''}`} />
                            </button> */}
                            <button onClick={toggleBasicFilters} className="flex items-center justify-between text-md w-full py-1 ml-2 pr-4 transition duration-300 ease-in-out group">
                                Search Filters
                                {showBasicFilters ? <MinusCircleIcon className="w-5 h-5" /> : <PlusCircleIcon className="w-5 h-5" />}
                            </button>
                            <div className='border-b-2 border-black mt-1 mx-2'></div>
                        {/* </div> */}
                        {/* <div className={`rounded-md bg-[#DDD9D0] ml-1 mr-1 mb-3 px-3 pt-2 transition-max-height duration-500 ease-in-out ${showBasicFilters ? 'max-h-96' : 'max-h-0'} z-10`}> */}
                        {/* <div className={`rounded-md bg-[#DDD9D0] ml-1 mr-1 mb-3 px-3 pt-2 ${showBasicFilters ? 'visible-opacity' : 'hidden-opacity'} overflow-visible`}> */}
                        <div className={`rounded-md mb-4 px-3 pt-2 transition-all ease-in-out duration-500 ${showBasicFilters ? 'max-h-96 opacity-1 visible' : 'max-h-0 opacity-0 invisible'}`}>
    
                            <div className='text-sm'>Company</div>
                            <div ref={searchRef} className="relative flex items-center flex-wrap border border-black rounded focus-within:ring-[#cfcfb4] focus-within:ring-offset focus-within:ring-[3px]">
                                
                                <input 
                                    type="text"
                                    value={companyInput}
                                    onChange={(e) => handleCompanySearchChange(e.target.value)}
                                    placeholder={filters.companyName.length > 0 ? "" : "Google" }
                                    className="flex-1 pl-2 min-w-px border-none rounded text-sm h-7 focus:ring-0 focus:border-none"
                                    style={{minWidth: '120px'}}  // Ensure input does not disappear when there are many tags
                                />
                                {isDropdownVisible && (
                                    <div className="absolute left-0 top-full mt-1 w-full text-sm bg-white border border-black shadow-solid rounded overflow-visible z-50 ">
                                        {searchResults.map((result, index) => (
                                            <div key={index}
                                                className="cursor-pointer hover:bg-black hover:text-white p-2 py-1"
                                                onClick={() => handleSelectCompany(result.name)}
                                            >
                                                {result.name}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className='ml-3'> 
                                {filters.companyName.map((name, index) => (
                                    // <div className='mr-2'>
                                        <span key={index} className="items-center text-white text-xs bg-black rounded-full pl-2 pr-2 py-1">
                                            {name}
                                            <button
                                                className="bg-transparent text-white text-sm ml-1 pl-1 border-l border-white"
                                                onClick={() => {
                                                    setFilters(prev => ({
                                                        ...prev,
                                                        companyName: prev.companyName.filter(n => n !== name)
                                                    }));
                                                }}
                                            >
                                                ×
                                            </button>
                                        </span>
                                    // </div>
                                ))}
                            </div>
                            <div className='text-sm mt-3'>Title</div>
                            <div ref={titleSearchRef} className="relative flex items-center flex-wrap border border-black rounded bg-white focus-within:ring-[#cfcfb4] focus-within:ring-offset focus-within:ring-[3px]">
                                
                                <input 
                                    type="text"
                                    value={titleInput}
                                    onChange={(e) => handleTitleSearchChange(e.target.value)}
                                    placeholder={filters.titleName.length > 0 ? "" : "Software Engineer" }
                                    className="flex-1 p-2 min-w-px border-none rounded h-7 text-sm focus:ring-0 focus:border-none"
                                    style={{minWidth: '120px'}}  // Ensure input does not disappear when there are many tags
                                />
                                {isTitleDropdownVisible && (
                                    <div className="absolute left-0 top-full mt-1 w-full text-sm bg-white border border-black shadow-solid rounded overflow-visible z-50 ">
                                        {titleSearchResults.map((result, index) => (
                                            <div key={index}
                                                className="cursor-pointer hover:bg-black hover:text-white p-2"
                                                onClick={() => handleSelectTitle(result.title)}
                                            >
                                                {result.title}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            {filters.titleName.map((name, index) => (
                                    <span key={index} className="items-center text-white text-xs bg-black rounded-full pl-2 pr-2 py-1">
                                        {name}
                                        <button
                                            className="bg-transparent text-white text-sm ml-1 pl-1 border-l border-white"
                                            onClick={() => {
                                                setFilters(prev => ({
                                                    ...prev,
                                                    titleName: prev.titleName.filter(n => n !== name)
                                                }));
                                            }}
                                        >
                                            ×
                                        </button>
                                    </span>
                                ))}
                            
                                <div className='text-sm mt-3'>Location</div>
                                <div ref={locationSearchRef} className="relative flex items-center flex-wrap border border-black rounded text-xs focus-within:ring-[#cfcfb4] focus-within:ring-offset focus-within:ring-[3px]">
                                    <input 
                                        type="text"
                                        value={locationInput}
                                        onChange={(e) => handleLocationSearchChange(e.target.value)}
                                        placeholder={filters.location.length > 0 ? "" : "New York, New York, United States" }
                                        className="flex-1 p-2 min-w-px border-none rounded text-sm h-7 focus:ring-0 focus:border-none"
                                        style={{minWidth: '120px'}}  // Ensure input does not disappear when there are many tags
                                    />
                                    {isLocationDropdownVisible && (
                                        <div className="absolute left-0 top-full mt-1 w-full text-sm bg-white border border-black shadow-solid rounded overflow-visible z-50 ">
                                            {locationSearchResults.map((result, index) => (
                                                <div key={index}
                                                    className="cursor-pointer hover:bg-black hover:text-white p-2"
                                                    onClick={() => handleSelectLocation(result.location)}
                                                >
                                                    {result.location}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div> 
                                {filters.location.map((name, index) => (
                                    <span key={index} className="items-center text-white text-xs bg-black rounded-full pl-2 pr-2 py-1">
                                    {name}
                                        <button
                                            className="bg-transparent text-white text-sm ml-1 pl-1 border-l border-white"
                                            onClick={() => {
                                                setFilters(prev => ({
                                                    ...prev,
                                                    location: prev.location.filter(n => n !== name)
                                                }));
                                            }}
                                        >
                                            ×
                                        </button>
                                    </span>
                                ))}
                            <div className='pb-3'>
                            </div>
                            
                        </div> 
                        {/* <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Offer Status</label>
                        <ul className="items-center mb-2 w-full text-sm font-medium text-gray-900 bg-white sm:flex dark:bg-gray-700 dark:text-white">
       
                            <li className="w-full border-b border-gray-200 sm:border-b-0 dark:border-gray-600">
                                <div className="flex items-center">
                                    <input 
                                        type="radio" 
                                        id="status-rejected" 
                                        name="status" 
                                        value="Denied" 
                                        onChange={handleChange} 
                                        checked={filters.status === 'Denied'} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="status-rejected" className="inline-flex items-center justify-center w-full p-2 text-gray-500 bg-white border border-gray-200 rounded-l-lg cursor-pointer dark:hover:text-gray-300 dark:border-gray-700 dark:peer-checked:text-blue-500 peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700">
                                        Rejected
                                    </label>
                                </div>
                            </li>
                            <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r-0 dark:border-gray-600">
                                <div className="flex items-center">
                                    <input 
                                        type="radio" 
                                        id="status-offered" 
                                        name="status" 
                                        value="Offered" 
                                        onChange={handleChange} 
                                        checked={filters.status === 'Offered'} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="status-offered" className="inline-flex items-center justify-center w-full p-2 text-gray-500 bg-white border border-gray-200 cursor-pointer dark:hover:text-gray-300 dark:border-gray-700 dark:peer-checked:text-blue-500 peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700">
                                        Offered
                                    </label>
                                </div>
                            </li>
                            <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r-0 dark:border-gray-600">
                                <div className="flex items-center">
                                    <input 
                                        type="radio" 
                                        id="status-accepted" 
                                        name="status" 
                                        value="Accepted" 
                                        onChange={handleChange} 
                                        checked={filters.status === 'Accepted'} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="status-accepted" className="inline-flex items-center justify-center w-full p-2 text-gray-500 bg-white border border-gray-200 rounded-r-lg cursor-pointer dark:hover:text-gray-300 dark:border-gray-700 dark:peer-checked:text-blue-500 peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700">
                                        Accepted
                                    </label>
                                </div>
                            </li>
                        </ul> */}
    
                        {/* <div className="border-black border-b font-bold pb-1 m-2">
                            Range Filters
                        </div> */}
    
                        <button onClick={toggleOptionsFilters} className="flex items-center justify-between text-md w-full py-1 ml-2 pr-4 transition duration-300 ease-in-out group ">
                            Options Filters
                            {showOptionsFilters ? <MinusCircleIcon className="w-5 h-5" /> : <PlusCircleIcon className="w-5 h-5" />}
                        </button>
                        <div className='border-b-2 border-black mt-1 mx-2'></div>
                        <div className={`rounded-md mt-2 mb-4 px-3 transition-max-height duration-500 ease-in-out ${showOptionsFilters ? 'max-h-full' : 'max-h-0'} overflow-hidden`}>
                            <label className="block text-sm font-medium text-gray-900 dark:text-white">Work Mode</label>
                            <ul className="items-center mb-2 w-full text-sm font-medium rounded sm:flex">
                                <li className="w-full rounded-l">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="workMode-remote" 
                                        name="workMode" 
                                        value="Remote" 
                                        onChange={handleChange} 
                                        checked={filters.workMode.includes('Remote')} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="workMode-remote" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-r-0 border-black rounded-l cursor-pointer ${filters.workMode.includes('Remote') ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        Remote
                                    </label>
                                    </div>
                                </li>
                                {/* In-Person Option */}
                                <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r-0">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="workMode-inperson" 
                                        name="workMode" 
                                        value="In-Person" 
                                        onChange={handleChange} 
                                        checked={filters.workMode.includes('In-Person')} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="workMode-inperson" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-r-0 border-black cursor-pointer ${filters.workMode.includes('In-Person') ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        In-Person
                                    </label>
                                    </div>
                                </li>
                                {/* Hybrid Option */}
                                <li className="w-full rounded-r">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="workMode-hybrid" 
                                        name="workMode" 
                                        value="Hybrid" 
                                        onChange={handleChange} 
                                        checked={filters.workMode.includes('Hybrid')} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="workMode-hybrid" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-black rounded-r cursor-pointer ${filters.workMode.includes('Hybrid') ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        Hybrid
                                    </label>
                                    </div>
                                </li>
                            </ul>
    
                            <label className="block text-sm font-medium text-gray-900 dark:text-white">Offer Status</label>
                            <ul className="items-center mb-4 w-full text-sm font-medium rounded sm:flex">
                                <li className="w-full rounded-l">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="status-rejected" 
                                        name="status" 
                                        value="Denied" 
                                        onChange={handleChange} 
                                        checked={filters.status.includes('Denied')} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="status-rejected" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-r-0 border-black rounded-l cursor-pointer ${filters.status.includes('Denied') ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                    Denied
                                    </label>
                                    </div>
                                </li>
                                {/* In-Person Option */}
                                <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r-0">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="status-offered" 
                                        name="status" 
                                        value="Offered" 
                                        onChange={handleChange} 
                                        checked={filters.status.includes('Offered')} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="status-offered" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-r-0 border-black cursor-pointer ${filters.status.includes('Offered') ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                    Offered
                                    </label>
                                    </div>
                                </li>
                                <li className="w-full rounded-r">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="status-accepted" 
                                        name="status" 
                                        value="Accepted" 
                                        onChange={handleChange} 
                                        checked={filters.status.includes('Accepted')} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="status-accepted" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-black rounded-r cursor-pointer ${filters.status.includes('Accepted') ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                    Accepted
                                    </label>
                                    </div>
                                </li>
                                {/* <li className="w-full rounded-r">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="workMode-hybrid" 
                                        name="workMode" 
                                        value="Hybrid" 
                                        onChange={handleChange} 
                                        checked={filters.workMode.includes('Hybrid')} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="workMode-hybrid" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-black rounded-r cursor-pointer ${filters.workMode.includes('Hybrid') ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        Hybrid
                                    </label>
                                    </div>
                                </li> */}
                            </ul>
    
                            <label className="block text-sm font-medium text-gray-900 dark:text-white">Highest Degree Achieved</label>
                            <ul className="items-center mb-4 w-full text-sm font-medium rounded">
                                <li className="w-full rounded-t">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="degree-highschool" 
                                        name="degree" 
                                        value="High School" 
                                        onChange={handleChange} 
                                        checked={filters.degree.includes("High School")} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="degree-highschool" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-b-0 border-black rounded-t cursor-pointer ${filters.degree.includes("High School") ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        High School
                                    </label>
                                    </div>
                                </li>
                                {/* In-Person Option */}
                                <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r-0">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="degree-associate" 
                                        name="degree" 
                                        value="Associate" 
                                        onChange={handleChange} 
                                        checked={filters.degree.includes("Associate")} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="degree-associate" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-b-0 border-black cursor-pointer ${filters.degree.includes("Associate") ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        Associate
                                    </label>
                                    </div>
                                </li>
                                <li className="w-full">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="degree-bachelors" 
                                        name="degree" 
                                        value="Bachelors" 
                                        onChange={handleChange} 
                                        checked={filters.degree.includes("Bachelors")} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="degree-bachelors" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-b-0 border-black cursor-pointer ${filters.degree.includes("Bachelors") ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        Bachelors
                                    </label>
                                    </div>
                                </li>
                                <li className="w-full">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="degree-masters" 
                                        name="degree" 
                                        value="Masters" 
                                        onChange={handleChange} 
                                        checked={filters.degree.includes("Masters")} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="degree-masters" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-b-0 border-black cursor-pointer ${filters.degree.includes("Masters") ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        Masters
                                    </label>
                                    </div>
                                </li>
                                <li className="w-full rounded-b">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="degree-doctoral"  
                                        name="degree" 
                                        value="Doctoral/PhD." 
                                        onChange={handleChange} 
                                        checked={filters.degree.includes("Doctoral/PhD.")} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="degree-doctoral" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-black rounded-b cursor-pointer ${filters.degree.includes("Doctoral/PhD.") ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        Doctoral/PhD.
                                    </label>
                                    </div>
                                </li>
                            </ul>
    
                            {/* <label className="block text-sm font-medium text-gray-900 dark:text-white">Level</label>
                            <ul className="items-center mb-4 w-full text-sm font-medium rounded">
                                <li className="w-full rounded-t">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="degree-highschool" 
                                        name="degree" 
                                        value="High School" 
                                        onChange={handleChange} 
                                        checked={filters.degree.includes("High School")} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="degree-highschool" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-b-0 border-black rounded-t cursor-pointer ${filters.degree.includes("High School") ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        Intern
                                    </label>
                                    </div>
                                </li>
                                <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r-0">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="degree-associate" 
                                        name="degree" 
                                        value="Associate" 
                                        onChange={handleChange} 
                                        checked={filters.degree.includes("Associate")} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="degree-associate" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-b-0 border-black cursor-pointer ${filters.degree.includes("Associate") ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        Junior
                                    </label>
                                    </div>
                                </li>
                                <li className="w-full">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="degree-bachelors" 
                                        name="degree" 
                                        value="Bachelors" 
                                        onChange={handleChange} 
                                        checked={filters.degree.includes("Bachelors")} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="degree-bachelors" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-b-0 border-black cursor-pointer ${filters.degree.includes("Bachelors") ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        Mid-Level
                                    </label>
                                    </div>
                                </li>
                                <li className="w-full">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="degree-bachelors" 
                                        name="degree" 
                                        value="Bachelors" 
                                        onChange={handleChange} 
                                        checked={filters.degree.includes("Bachelors")} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="degree-bachelors" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-b-0 border-black cursor-pointer ${filters.degree.includes("Bachelors") ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        Senior
                                    </label>
                                    </div>
                                </li>
                                <li className="w-full">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="degree-bachelors" 
                                        name="degree" 
                                        value="Bachelors" 
                                        onChange={handleChange} 
                                        checked={filters.degree.includes("Bachelors")} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="degree-bachelors" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-b-0 border-black cursor-pointer ${filters.degree.includes("Bachelors") ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        Staff
                                    </label>
                                    </div>
                                </li>
                                <li className="w-full">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="degree-masters" 
                                        name="degree" 
                                        value="Masters" 
                                        onChange={handleChange} 
                                        checked={filters.degree.includes("Masters")} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="degree-masters" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-b-0 border-black cursor-pointer ${filters.degree.includes("Masters") ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        Senior Staff
                                    </label>
                                    </div>
                                </li>
                                <li className="w-full rounded-b">
                                    <div className="flex items-center">
                                    <input 
                                        type="checkbox" 
                                        id="degree-doctoral"  
                                        name="degree" 
                                        value="Doctoral/PhD." 
                                        onChange={handleChange} 
                                        checked={filters.degree.includes("Doctoral/PhD.")} 
                                        className="hidden peer" 
                                    />
                                    <label htmlFor="degree-doctoral" className={`inline-flex items-center justify-center w-full px-2 py-1 border border-black rounded-b cursor-pointer ${filters.degree.includes("Doctoral/PhD.") ? 'bg-black text-white' : 'bg-white text-black'}`}>
                                        Distinguished
                                    </label>
                                    </div>
                                </li>
                            </ul> */}
                        </div>
    
                        <button onClick={toggleAdvancedFilters} className="flex items-center justify-between text-md w-full py-1 ml-2 pr-4 transition duration-300 ease-in-out group">
                            Range Filters
                            {showAdvancedFilters ? <MinusCircleIcon className="w-5 h-5" /> : <PlusCircleIcon className="w-5 h-5" />}
                        </button>
                        <div className='border-b-2 border-black mt-1 mx-2'></div>
                        {/* {`rounded-md bg-[#DDD9D0] ml-1 mr-1 mb-3 px-3 pt-2 transition-all ease-in-out duration-500 ${showBasicFilters ? 'max-h-96 opacity-1 visible' : 'max-h-0 opacity-0 invisible'}`} */}
                        <div className={`rounded-md mb-3 px-3 transition-max-height duration-500 ease-in-out ${showAdvancedFilters ? 'max-h-96' : 'max-h-0'} overflow-hidden`}>
                            <div className="text-sm mt-2">Experience</div>
                            <div className="flex items-center w-full">
                                    <input
                                    type="number"
                                    placeholder="Min"
                                    value={filters.minExperience}
                                    onChange={(e) => handleSalaryChange(e, 'minExperience')}
                                    style={{
                                        appearance: 'none',
                                        WebkitAppearance: 'none', // Note: React inline styles require the vendor prefix in camelCase
                                        MozAppearance: 'none',
                                        backgroundImage: 'none',
                                        backgroundColor: 'none',
                                        color: 'none',
                                        paddingRight: 0
                                    }}
                                    className="flex-1 border rounded p-2 mr-1 mt-1 h-8 text-xs min-w-[50px] max-w-xs border-black focus:border-black focus:ring-[#cfcfb4] focus:ring-offset focus:ring-[3px]"
                                />
                                -
                                <input
                                    type="number"
                                    placeholder="Max"
                                    value={filters.maxExperience}
                                    onChange={(e) => handleSalaryChange(e, 'maxExperience')}
                                    className="flex-1 border rounded p-2 ml-1 mt-1 h-8 text-xs min-w-[50px] max-w-xs border-black focus:border-black focus:ring-[#cfcfb4] focus:ring-offset focus:ring-[3px]"
                                />
                            </div>
    
                            <div className='inline-flex justify-between items-center w-full mt-4'>
                                <label className="block text-sm">Total Compensation</label>
                                <select
                                    value={currency}
                                    onChange={(e) => setCurrency(e.target.value)}
                                    style={{
                                        appearance: 'none',
                                        WebkitAppearance: 'none', // Note: React inline styles require the vendor prefix in camelCase
                                        MozAppearance: 'none',
                                        backgroundImage: 'none',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        paddingRight: 0
                                    }}
                                    className='rounded border text-xs ml-2 p-0 pl-2 h-5 cursor-pointer'
                                >
                                    {Object.keys(rates).map((key) => (
                                        <option key={key} value={key} className='bg-white text-black'>{key}</option>
                                    ))}
                                </select>
                            </div>
                            
                            <div className="flex items-center w-full">
                                {/* <input type="number" id="minSalary" name="minSalary" value={filters.minSalary} onChange={handleChange}
                                    className="relative bg-white border text-sm rounded block w-auto ml-2 mr-2 focus-within:ring-[#cfcfb4] focus-within:ring-offset focus-within:ring-[3px]"
                                    placeholder="0" required />
                                <div>
                                -
                                </div>
                                <input type="number" id="maxSalary" name="maxSalary" value={filters.maxSalary} onChange={handleChange}
                                className="relative bg-white border text-sm rounded block w-auto ml-2 mr-2 focus-within:ring-[#cfcfb4] focus-within:ring-offset focus-within:ring-[3px]"
                                placeholder="1,000,000" required /> */}
                                    <input
                                    type="number"
                                    placeholder="Min"
                                    value={filters.minTotalCompensation}
                                    onChange={(e) => handleSalaryChange(e, 'minTotalCompensation')}
                                    className="flex-1 border rounded p-2 mr-1 mt-1 h-8 text-xs min-w-[50px] max-w-xs border-black focus:border-black focus:ring-[#cfcfb4] focus:ring-offset focus:ring-[3px]"
                                />
                                -
                                <input
                                    type="number"
                                    placeholder="Max"
                                    value={filters.maxTotalCompensation}
                                    onChange={(e) => handleSalaryChange(e, 'maxTotalCompensation')}
                                    className="flex-1 border rounded p-2 ml-1 mt-1 h-8 text-xs min-w-[50px] max-w-xs border-black focus:border-black focus:ring-[#cfcfb4] focus:ring-offset focus:ring-[3px]"
                                />
                            </div>
    
                            <div className='inline-flex justify-between items-center w-full pr-3 mt-4'>
                                <label className="text-sm">Base Salary Range</label>
                                
                            </div>
                            
                            <div className="flex items-center w-full">
                                {/* <input type="number" id="minSalary" name="minSalary" value={filters.minSalary} onChange={handleChange}
                                    className="relative bg-white border text-sm rounded block w-auto ml-2 mr-2 focus-within:ring-[#cfcfb4] focus-within:ring-offset focus-within:ring-[3px]"
                                    placeholder="0" required />
                                <div>
                                -
                                </div>
                                <input type="number" id="maxSalary" name="maxSalary" value={filters.maxSalary} onChange={handleChange}
                                className="relative bg-white border text-sm rounded block w-auto ml-2 mr-2 focus-within:ring-[#cfcfb4] focus-within:ring-offset focus-within:ring-[3px]"
                                placeholder="1,000,000" required /> */}
                                    <input
                                    type="number"
                                    placeholder="Min"
                                    value={filters.minSalary}
                                    onChange={(e) => handleSalaryChange(e, 'minSalary')}
                                    className="flex-1 border rounded p-2 mr-1 mt-1 h-8 text-xs min-w-[50px] max-w-xs border-black focus:border-black focus:ring-[#cfcfb4] focus:ring-offset focus:ring-[3px]"
                                />
                                -
                                <input
                                    type="number"
                                    placeholder="Max"
                                    value={filters.maxSalary}
                                    onChange={(e) => handleSalaryChange(e, 'maxSalary')}
                                    className="flex-1 border rounded p-2 ml-1 mt-1 h-8 text-xs min-w-[50px] max-w-xs border-black focus:border-black focus:ring-[#cfcfb4] focus:ring-offset focus:ring-[3px]"
                                />
                            </div>
    
                            <div className='inline-flex justify-between items-center w-full pr-3 mt-4'>
                                <label className="text-sm">Stock Options Range</label>
                                
                            </div>
                            
                            <div className="flex items-center w-full">
                                {/* <input type="number" id="minSalary" name="minSalary" value={filters.minSalary} onChange={handleChange}
                                    className="relative bg-white border text-sm rounded block w-auto ml-2 mr-2 focus-within:ring-[#cfcfb4] focus-within:ring-offset focus-within:ring-[3px]"
                                    placeholder="0" required />
                                <div>
                                -
                                </div>
                                <input type="number" id="maxSalary" name="maxSalary" value={filters.maxSalary} onChange={handleChange}
                                className="relative bg-white border text-sm rounded block w-auto ml-2 mr-2 focus-within:ring-[#cfcfb4] focus-within:ring-offset focus-within:ring-[3px]"
                                placeholder="1,000,000" required /> */}
                                    <input
                                    type="number"
                                    placeholder="Min"
                                    value={filters.minStock}
                                    onChange={(e) => handleSalaryChange(e, 'minStock')}
                                    className="flex-1 border rounded p-2 mr-1 mt-1 h-8 text-xs min-w-[50px] max-w-xs border-black focus:border-black focus:ring-[#cfcfb4] focus:ring-offset focus:ring-[3px]"
                                />
                                -
                                <input
                                    type="number"
                                    placeholder="Max"
                                    value={filters.maxStock}
                                    onChange={(e) => handleSalaryChange(e, 'maxStock')}
                                    className="flex-1 border rounded p-2 ml-1 mt-1 h-8 text-xs min-w-[50px] max-w-xs border-black focus:border-black focus:ring-[#cfcfb4] focus:ring-offset focus:ring-[3px]"
                                />
                            </div>
    
                            <div className='inline-flex justify-between items-center w-full pr-3 mt-4'>
                                <label className="text-sm">Average Yearly Target Bonus Range</label>
                            </div>
                            
                            <div className="flex items-center w-full">
                                {/* <input type="number" id="minSalary" name="minSalary" value={filters.minSalary} onChange={handleChange}
                                    className="relative bg-white border text-sm rounded block w-auto ml-2 mr-2 focus-within:ring-[#cfcfb4] focus-within:ring-offset focus-within:ring-[3px]"
                                    placeholder="0" required />
                                <div>
                                -
                                </div>
                                <input type="number" id="maxSalary" name="maxSalary" value={filters.maxSalary} onChange={handleChange}
                                className="relative bg-white border text-sm rounded block w-auto ml-2 mr-2 focus-within:ring-[#cfcfb4] focus-within:ring-offset focus-within:ring-[3px]"
                                placeholder="1,000,000" required /> */}
                                    <input
                                    type="number"
                                    placeholder="Min"
                                    value={filters.minTargetBonus}
                                    onChange={(e) => handleSalaryChange(e, 'minTargetBonus')}
                                    className="flex-1 border rounded p-2 mr-1 mt-1 h-8 text-xs min-w-[50px] max-w-xs border-black focus:border-black focus:ring-[#cfcfb4] focus:ring-offset focus:ring-[3px]"
                                />
                                -
                                <input
                                    type="number"
                                    placeholder="Max"
                                    value={filters.maxTargetBonus}
                                    onChange={(e) => handleSalaryChange(e, 'maxTargetBonus')}
                                    className="flex-1 border rounded p-2 ml-1 mt-1 h-8 text-xs min-w-[50px] max-w-xs border-black focus:border-black focus:ring-[#cfcfb4] focus:ring-offset focus:ring-[3px]"
                                />
                            </div>
    
                            <div className='inline-flex mt-4'>
                                <label className="text-sm">Total Sign-On Bonus Range</label>
                            </div>
                            
                            <div className="flex items-center w-full mb-3">
                                {/* <input type="number" id="minSalary" name="minSalary" value={filters.minSalary} onChange={handleChange}
                                    className="relative bg-white border text-sm rounded block w-auto ml-2 mr-2 focus-within:ring-[#cfcfb4] focus-within:ring-offset focus-within:ring-[3px]"
                                    placeholder="0" required />
                                <div>
                                -
                                </div>
                                <input type="number" id="maxSalary" name="maxSalary" value={filters.maxSalary} onChange={handleChange}
                                className="relative bg-white border text-sm rounded block w-auto ml-2 mr-2 focus-within:ring-[#cfcfb4] focus-within:ring-offset focus-within:ring-[3px]"
                                placeholder="1,000,000" required /> */}
                                    <input
                                    type="number"
                                    placeholder="Min"
                                    value={filters.minSignOnBonus}
                                    onChange={(e) => handleSalaryChange(e, 'minSignOnBonus')}
                                    className="flex-1 border rounded p-2 mr-1 mt-1 h-8 text-xs min-w-[50px] max-w-xs border-black focus:border-black focus:ring-[#cfcfb4] focus:ring-offset focus:ring-[3px]"
                                />
                                -
                                <input
                                    type="number"
                                    placeholder="Max"
                                    value={filters.maxSignOnBonus}
                                    onChange={(e) => handleSalaryChange(e, 'maxSignOnBonus')}
                                    className="flex-1 border rounded p-2 ml-1 mt-1 h-8 bg-white text-xs min-w-[50px] max-w-xs border-black focus:border-black focus:ring-[#cfcfb4] focus:ring-offset focus:ring-[3px]"
                                />
                            </div>
                                {/* </div> */}
                            {/* </div> */}
                        </div>
                        <div className="flex justify-between mt-8 mb-2">
                            <button onClick={clearFilters} type="button" className=" hover:bg-black hover:text-white border border-black font-medium rounded text-sm min-w-32 py-2.5 mx-2">
                                Clear All
                            </button>
                            <button onClick={fetchFilteredJobOffers} type="button" className="text-white bg-black font-medium rounded text-sm min-w-32 py-2.5 mr-2">
                                Apply
                            </button>
                        </div>
                        </div>
                    </div>
                    <div className="flex-grow p-4 lg:w-60">
                        <section class="flex items-center border-b ">
                            <div class="w-full max-w-screen-xl mx-auto">
                                <div class="relative sm:rounded-lg">
                                    <div class="flex-row inline-flex items-center justify-between p-4 space-y-3 sm:flex sm:space-y-0 sm:space-x-4">
                                        <div>
                                        {/* <h5 class="mr-3 font-semibold dark:text-white"> */}
                                            <span class="text-gray-500">{JSON.stringify(documentCount, null, 2) }</span>
                                            <span class="dark:text-white"> Results</span>
                                        {/* </h5> */}
                                        {/* <p class="text-gray-500 dark:text-gray-400">1 to 3 of {JSON.stringify(documentCount, null, 2) } Results</p> */}
                                        </div>
                                        <div ref={sortingSearchRef} className="relative">
                                            <button
                                                onClick={() => setShowDropdown(!showDropdown)}
                                                className="border-2 border-black rounded focus:bg-black focus:text-white"
                                            >
                                                <SortDescendingIcon className="w-5 h-5 m-2 bg-none text-black rounded focus:bg-black focus:text-white" />
                                            </button>
                                            {showDropdown && (
                                                <div className="absolute right-0 mt-2 w-48 border border-black bg-white shadow-solid rounded z-1000">
                                                    <div className="p-2">
                                                        {Object.entries(sortOptionsMap).map(([friendlyName, { field, enabledStatuses }]) => {
                                                            // const isEnabled = enabledStatuses.includes(filters.status) || enabledStatuses.includes("Any");
                                                            const isEnabled = isSortingOptionEnabled(enabledStatuses); // Updated check
                                                            return (
                                                                <div
                                                                    key={friendlyName}
                                                                    onClick={() => {
                                                                        if (isEnabled) {
                                                                            setSortField(field);
                                                                            setShowDropdown(false);
                                                                        }
                                                                    }}
                                                                    className={`flex items-center justify-between p-2 text-sm  hover:bg-gray-100 cursor-pointer ${filters.sortField === field ? "bg-gray-200" : ""} ${!isEnabled ? "text-gray-400 cursor-not-allowed" : ""}`}
                                                                >
                                                                    {friendlyName}
                                                                    {sortField === field && isEnabled && <span>&#10003;</span>}
                                                                </div>
                                                            );
                                                        })}
                                                        <hr className="my-2" />
                                                        {["Ascending", "Descending"].map((order) => (
                                                            <div
                                                                key={order}
                                                                onClick={() => {
                                                                    setSortOrder(order.toLowerCase());
                                                                    setShowDropdown(false);
                                                                }}
                                                                className={`flex items-center justify-between p-2 text-sm hover:bg-gray-100 cursor-pointer ${filters.sortOrder === order.toLowerCase() ? "bg-gray-200" : ""}`}
                                                            >
                                                                {order}
                                                                {sortOrder === order.toLowerCase() && <span>&#10003;</span>}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <button onClick={toggleFilterDrawer} className={`lg:hidden absolute p-2  bg-blue-500 text-white rounded-full ${results.length > 0 ? 'block' : 'hidden'}`}
                                            aria-controls="filter-drawer"
                                        >
                                                {isFilterDrawerOpen ? <ChevronDownIcon className="w-6 h-6" /> : <ChevronUpIcon className="w-6 h-6" />}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div className="w-full m-3">
                            {results.map((jobOffer, index) => (
                                <div key={index} className={`bg-white border border-black ml-3 mr-3 cursor-pointer border-2 ${index == 0 ? '' : 'border-t-0'} ${index + 1 == results.length ? '' : ''} `} onClick={() => handleCardClick(jobOffer.documentId)}>
                                    {/* <div className="job-info"> */}
                                    <div className="flex justify-between items-center w-full">
                                        <div className="truncate text-2xl ml-5 mt-5 ">{jobOffer.company}</div>
                                        { jobOffer.status !== "Denied" && (
                                            <div className="text-2xl mr-5 mt-5">
                                            {/* {(Math.round(jobOffer.baseSalary)?.toLocaleString('en-US', {style: 'currency', currency: 'USD' }) || "$0")} */}
                                            {(jobOffer.totalCompensation?.toLocaleString('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD',
                                                    minimumFractionDigits: 0,  // Ensures no decimals are shown
                                                    maximumFractionDigits: 0   // Ensures no decimals are shown
                                                }) || "$-")
                                            }
        
                                            </div>
                                        )}
                                        
                                    </div>
                                    <div className="flex justify-between items-center w-full">
                                        <div className="truncate text-md ml-5">{jobOffer.title}&nbsp;{(jobOffer.title === "Other") && ("(" + jobOffer.customTitle + ")")}
                                        </div>
                                        { jobOffer.status !== "Denied" && (
                                            <div className="text-md mr-5">
                                            {(jobOffer.baseSalary?.toLocaleString('en-US', { style: 'currency', currency: 'USD', notation: 'compact' }) || "$-")}&nbsp;/&nbsp; 
                                            {(jobOffer.stock?.toLocaleString('en-US', { style: 'currency', currency: 'USD', notation: 'compact'  }) || "$-")}&nbsp;/&nbsp; 
                                            {(jobOffer.targetBonus?.toLocaleString('en-US', { style: 'currency', currency: 'USD', notation: 'compact'  }) || "$-")}
                                            </div>
                                        )}
                                        
                                    </div>
                                    <div className="flex justify-between items-center w-full mb-6 mt-8">
                                        <div className="truncate text-sm ml-5">{jobOffer.location}</div>
                                        {(jobOffer.status === "Accepted") && (
                                            <div className="inline-flex text-xs mr-5 border-b-2 border-[#038744] text-[#038744]">
                                                <div className='pt'>
                                                    <i class="fa-solid fa-check-double" style={{color: '#038744'}}>
                                                    {/* <span class="material-icons-outlined">done_all</span> */}
                                                    </i>
                                                </div>
                                                <div className='pl-1'>{jobOffer.status}</div>
                                            </div>
                                        )}
                                        
                                        {(jobOffer.status === "Offered") && (
                                            <div className="inline-flex text-xs mr-5  text-center border-b-2 border-[#3c82f6] text-[#3c82f6]">
                                                <div className='pt'>
                                                    <i class="fa-solid fa-check" style={{color: '#3c82f6'}}>
                                                    {/* <span class="material-icons-outlined">done_all</span> */}
                                                    </i>
                                                </div>
                                                <div className='pl-1'>{jobOffer.status}</div>
                                            </div>
                                        )}
    
                                        {(jobOffer.status === "Denied") && (
                                            <div className="inline-flex text-xs mr-5 pt-[0.5px] text-center border-b-2 border-[#d9544f] text-[#d9544f]">
                                                <div className='pt'>
                                                    <i class="fa-solid fa-xmark" style={{color: '#d9544f'}}>
                                                    {/* <span class="material-icons-outlined">done_all</span> */}
                                                    </i>
                                                </div>
                                                <div className='pl-1'>Denied</div>
                                            </div>
                                        )}
                                            {/* #3c82f6 */}
                                    </div>
                                        {/* <div><i className="fas fa-comment"></i> {jobOffer.commentCount}</div> */}
                                    <div className='inline-flex justify-between items-center w-full ml-5 mb-2 mr-5'>
                                        <div>
                                            <div className='inline-flex mr-2'>
                                                <div className='mr-1'>
                                                    <i class="fa-solid fa-hands-clapping"></i> 
                                                </div>
                                                
                                                {jobOffer.likes}
                                            </div>
                                            <div className='inline-flex mr-2'>
                                                <div className='mr-1'>
                                                    <i class="fa-regular fa-comment"></i> 
                                                </div>
                                                {jobOffer.commentCount}
                                            </div>
                                            
                                        </div>
                                        <div className='mr-5'>
                                            {/* <div className='inline-flex mr-3'>
                                                <i class="fa-solid fa-arrow-up-from-bracket"></i>
                                            </div> */}
                                            <div className='inline-flex mr-5'>
                                                {/* <button onClick={(e) => toggleBookmark(jobOffer.documentId, jobOffer.offerId, e)}> */}
                                                    {/* {bookmarks[jobOffer.documentId]?.has(jobOffer.offerId.toString()) ? <i class="fa-solid fa-bookmark"></i> : <i class="fa-regular fa-bookmark"></i>} */}
                                                    {bookmarks?.has(jobOffer?.documentId.toString()) ? <i class="fa-solid fa-bookmark"></i> : <i class="fa-regular fa-bookmark"></i>}
                                                {/* </button> */}
                                                
                                            </div>
                                        </div>
                                        
                                        
                                        
                                    </div>
                                    {/* </div> */}
                                    {/* <button onClick={(e) => toggleBookmark(jobOffer.documentId, jobOffer.offerId, e)}>
                                        {bookmarks[jobOffer.documentId]?.has(jobOffer.offerId.toString()) ? 'Unbookmark' : 'Bookmark'}
                                    </button> */}
                                </div>
                            ))}
                        </div>
                        <div className="flex justify-center items-center mt-4">
                            <button onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))}
                                    disabled={currentPage === 1}
                                    className="mr-2 p-0 rounded border border-stone-300 hover:bg-black hover:border-black disabled:cursor-not-allowed">
                                <ChevronLeftIcon className="w-5 h-5 m-2 text-stone-700 hover:text-white"/>
                            </button>
                            
                            {currentPage > 3 && (
                                <>
                                    <button onClick={() => setCurrentPage(1)} className="w-10 h-10 rounded">
                                        1
                                    </button>
                                    {currentPage > 4 && <span className="mx-2">...</span>}
                                </>
                            )}
    
                            {[...Array(totalPages).keys()]
                                .filter(pageNumber => pageNumber + 1 >= currentPage - 2 && pageNumber + 1 <= currentPage + 2)
                                .map(pageNumber => (
                                    <button key={pageNumber} onClick={() => setCurrentPage(pageNumber + 1)}
                                            className={`w-10 h-10 ${currentPage === pageNumber + 1 ? 'text-white bg-black' : ''} rounded`}>
                                        {pageNumber + 1}
                                    </button>
                            ))}
    
                            {currentPage < totalPages - 2 && (
                                <>
                                    {currentPage < totalPages - 3 && <span className="mx-2">...</span>}
                                    <button onClick={() => setCurrentPage(totalPages)} className="w-10 h-10 rounded">
                                        {totalPages}
                                    </button>
                                </>
                            )}
                            <button onClick={() => setCurrentPage(Math.min(currentPage + 1, totalPages))}
                                    disabled={currentPage === totalPages}
                                    className="ml-2 p-0 rounded border border-stone-300 hover:bg-black hover:border-black disabled:cursor-not-allowed">
                                <ChevronRightIcon className="w-5 h-5 m-2 text-stone-700 hover:text-white"/>
                            </button>
                        </div>
                    </div>
                </div> 
            </div>
        </>
    );
}

export default Browse;
